import {
  FiBell, FiBriefcase, FiStar, FiCheck, FiXCircle, FiUsers, FiUserCheck, FiUserX, FiLogOut,
  FiBookOpen, FiAward, FiUserPlus, FiCalendar, FiFolder, FiMessageSquare, FiHeart, FiRepeat,
  FiBookmark, FiMessageCircle, FiMail,
} from "react-icons/fi";

// Every notification type gets a distinct icon + color + a human label —
// used anywhere a notification is rendered (bell dropdown, full Inbox)
// instead of showing the raw type string ("community_message") as an
// uppercase text pill, which reads as a technical tag rather than a
// notification. Single source of truth so the bell and the Inbox can't
// drift into two different visual systems for the same data.
export const NOTIFICATION_TYPE_CONFIG = {
  new_job: { icon: FiBriefcase, color: "bg-primary-50 text-primary-600", label: "New job" },
  shortlisted: { icon: FiStar, color: "bg-emerald-50 text-emerald-600", label: "Shortlisted" },
  accepted: { icon: FiCheck, color: "bg-emerald-50 text-emerald-600", label: "Application accepted" },
  rejected: { icon: FiXCircle, color: "bg-slate-100 text-slate-500", label: "Application update" },
  new_community: { icon: FiUsers, color: "bg-primary-50 text-primary-600", label: "New community" },
  request_accepted: { icon: FiUserCheck, color: "bg-emerald-50 text-emerald-600", label: "Join request approved" },
  request_rejected: { icon: FiUserX, color: "bg-red-50 text-red-500", label: "Join request declined" },
  removed_from_community: { icon: FiLogOut, color: "bg-red-50 text-red-500", label: "Removed from community" },
  new_course: { icon: FiBookOpen, color: "bg-primary-50 text-primary-600", label: "New course" },
  course_complete: { icon: FiAward, color: "bg-emerald-50 text-emerald-600", label: "Course completed" },
  job_application: { icon: FiBriefcase, color: "bg-amber-50 text-amber-600", label: "New application" },
  join_request: { icon: FiUserPlus, color: "bg-amber-50 text-amber-600", label: "New join request" },
  event_created: { icon: FiCalendar, color: "bg-primary-50 text-primary-600", label: "Event created" },
  event_updated: { icon: FiCalendar, color: "bg-primary-50 text-primary-600", label: "Event updated" },
  project_created: { icon: FiFolder, color: "bg-primary-50 text-primary-600", label: "Project created" },
  project_updated: { icon: FiFolder, color: "bg-primary-50 text-primary-600", label: "Project updated" },
  application_feedback: { icon: FiMessageSquare, color: "bg-primary-50 text-primary-600", label: "Application feedback" },
  like: { icon: FiHeart, color: "bg-rose-50 text-rose-600", label: "Like" },
  repost: { icon: FiRepeat, color: "bg-emerald-50 text-emerald-600", label: "Repost" },
  save: { icon: FiBookmark, color: "bg-amber-50 text-amber-600", label: "Save" },
  comment: { icon: FiMessageCircle, color: "bg-rose-50 text-rose-600", label: "Comment" },
  direct_message: { icon: FiMail, color: "bg-primary-50 text-primary-600", label: "Direct message" },
  community_message: { icon: FiMessageSquare, color: "bg-primary-50 text-primary-600", label: "Community chat" },
  default: { icon: FiBell, color: "bg-slate-100 text-slate-500", label: "Notification" },
};

export function getNotificationTypeConfig(type) {
  return NOTIFICATION_TYPE_CONFIG[type] || NOTIFICATION_TYPE_CONFIG.default;
}
